import { useApi } from './useApi';

export function useRole() {
  const { fetchData, postData, loading } = useApi();

  const getRolesApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/roles', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const getPermissionsApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/permissions', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const updateRolePermissionsApi = async (roleId, payload) => {
    try {
      const result = await postData(`/api/roles/${roleId}/update-permissions`, payload);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  return { getRolesApi, getPermissionsApi, updateRolePermissionsApi, loading };
}
